import React from 'react';
import './status.scss';

const Status = ({ value, activeText = 'Active' }) => {
  return (
    <>
      <div className={value === activeText ? 'status__orb-positive': 'status__orb-negative'} aria-hidden={true} />
      {value}
    </>
  );
};

export default Status;
